import { isRecord } from '@/utils/objects';
import type { InboundNode } from '../types';
import { extractFilters, toNumber } from './parse-helpers';

/**
 * Parse inbound message conditions.
 * Handles: { event: { type: 'inbound', ... }, times, within, inverse }
 *          { type: 'inbound', times, within, inverse }
 */
export function parseInbound(raw: Record<string, unknown>): InboundNode | null {
  const event = isRecord(raw.event) ? raw.event : undefined;
  if (event?.type === 'inbound') {
    const parsed = extractFilters(event.filters);
    const eventFilter = isRecord(raw.event_filter) ? raw.event_filter : undefined;
    return {
      type: 'inbound',
      inverse: (eventFilter?.inverse ?? raw.inverse) === true,
      times: toNumber(eventFilter?.times ?? raw.times),
      within: toNumber(eventFilter?.within ?? raw.within),
      filters: parsed?.filters,
      filtersOperator: parsed?.operator,
    };
  }

  if (raw.type === 'inbound') {
    const parsed = extractFilters(raw.filters);
    return {
      type: 'inbound',
      inverse: raw.inverse === true,
      times: toNumber(raw.times),
      within: toNumber(raw.within),
      filters: parsed?.filters,
      filtersOperator: parsed?.operator,
    };
  }

  return null;
}
